export default {
  ngWords: [],
  numberUnReadFineplayApprove: 0,
  notifications: [],
  numberSurveyNotComplete: 0
}



// WEBPACK FOOTER //
// ./src/store/modules/masterData/state.js